/**
 * 配置编译环境和线上环境之间的切换
 * IS_TEST: 是否为测试环境
 * baseUrl: 域名地址
 * mPayBaseUrl: 支付接口域名地址
 * paymentUrl: 收银台跳转地址
 *
 */

let baseUrl = ''
let mPayBaseUrl = ''
let paymentUrl = ''
let emAppUrl = ''
let EMONEY_BS = ''

/**
 * 正式地址
 */
baseUrl = 'https://emapp.emoney.cn/transfer/mt.emoney.cn'
mPayBaseUrl = 'https://emapp.emoney.cn/transfer/mpay.emoney.cn'
paymentUrl = 'https://appstatic.emoney.cn/ymstock/money/views/index.html'
emAppUrl = 'https://emapp.emoney.cn'
EMONEY_BS = 'https://emapp.emoney.cn/transfer/bs.m.emoney.cn'

/**
 * 测试地址
 */
if (process.env.__ENV) {
  baseUrl = 'https://mobiletest.emoney.cn/mt'
  mPayBaseUrl = 'https://mobiletest.emoney.cn/mpay'
  paymentUrl = 'https://mobiletest.emoney.cn/ms/html/web/ymstock/money/views/index.html'
  emAppUrl = 'https://mobiletest.emoney.cn/emapp'
  EMONEY_BS = 'https://mbs.emoney.cn'
}

export { baseUrl, mPayBaseUrl, paymentUrl, emAppUrl, EMONEY_BS }



// WEBPACK FOOTER //
// ./src/config/index.js